import React from 'react';
import { ComponentDoc, CodeExample } from '@cimpress/react-components';
import IntroCode from '!raw-loader!./introcode';

const remarks = (
  <div>
    <p>
      Welcome! This page is intended to get you started using{' '}
      <code>
        <a target="_new" href="https://www.npmjs.com/package/@cimpress/react-components">
          @cimpress/react-components
        </a>
      </code>
      .
    </p>
    <h5>Golbal Styles</h5>
    <p>
      In version 16, we removed the CSS Loader and external stylesheets in favor of a CSS-in-JS approach. If you are
      upgrading from an earlier version, please make sure you remove any old Cimpress stylesheets and the CSS Loader.
    </p>
    <p>
      To handle the few style globals that are not baked in to individual components (ie font size and color, page
      background color) there is now a <code>GlobalStyles</code> component. Simply include it in your app to get these
      styles applied.
    </p>
    <CodeExample code={IntroCode} />
    <h3>Helpful Pointers</h3>
    <h5>Import Patterns</h5>
    <p>
      In earlier versions, we recommended importing components directly from their respective locations in{' '}
      <code>@cimpress/react-components/lib</code> to minimize bundle size. Tree-shaking has come a long way since then,
      and we now recommend using the standard import pattern and letting your bundler take care of the rest.
    </p>
    <h5>
      Rest Syntax for Props (<code>...rest</code>)
    </h5>
    <p>
      Many components will forward any additional props that are not explicitly defined in the component's documentation
      along to the surrounding DOM element of the rendered content. For example, passing a <code>style</code> prop to
      the <code>FlexBox</code> component will cause your inline styles to be applied to the parent <code>div</code>.
    </p>
  </div>
);

export default () => <ComponentDoc name="Introduction" demoName="Usage" remarks={remarks} includeTabs={false} />;
